import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class ScoreImgDiv extends Component {
  static propTypes = {
    imgs: PropTypes.array.isRequired,
  };

  constructor (props) {
    super(props);
    this.state = {
      text: this.props.text,
      showMedal: this.props.showMedal,
    };
  }



  render() {
    // const iconList = this.props.imgs.map((img, index) =>
    //   <img
    //     key={index}
    //     src={img}
    //     alt={'gameState-icon'}/>
    // );
    // const iconList = this.props.imgs.map((img, index) =>
    //   <img
    //     key={index}
    //     src={img}
    //     alt={'group-icon'}/>
    // );

    return (
      <div className={'score-div imgs'}>
        {this.props.imgs.map((img, index) =>
          <img
            key={index}
            src={img}
            alt={'gameState-icon'}/>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/ScoreImgDiv.js